import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { ToastrService } from 'ngx-toastr';
import { GradingAssessmentsService } from '../../../../../_services/grading-assessments/grading-assessments.service';
import { attendanceService } from 'src/app/_services';
import { StudentAttendace } from 'src/app/_models';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
declare var $;

@Component({
  selector: 'app-report-card-template',
  templateUrl: './report-card-template.component.html',
  styleUrls: ['./report-card-template.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportCardTemplateComponent implements OnInit {
  @Input('selectedStudentId') selectedStudentId:any = null;
  progressReportData:any;
  reportStudentInfo:any = {};
  progressSubjects:any;
  studentAttendance:StudentAttendace;
  settings:Settings;
  constructor(private svc:GradingAssessmentsService, public appSettings: AppSettings,public toastr: ToastrService,private attendaceSrv: attendanceService){
    this.settings = this.appSettings.settings;
  }
  ngOnInit() {
    // this.academicYearId = this.mainFilterSvc.globalFilterObj.academicYearId;
    this.getProgressAssessmentCategoriesData();
    this.getProgressData();
    this.getReportStudentInfo();
    this.getStudentAttendaceByStudentId();
  }

  getProgressAssessmentCategoriesData() {
    this.svc.getProgressAssessmentCategoriesData(this.selectedStudentId).subscribe(data => {
      this.progressReportData = data;
     console.log(data);
    },
      () => {
        alert('error');
      });
  }
  getProgressData() {
    this.svc.getProgressData(this.selectedStudentId).subscribe(data => {
      this.progressSubjects = data;
      console.log('dynamic', data);
    },
      () => {
        alert('error');
      });
  }
  getSubjects(semesterId) {
    if (this.progressSubjects)
      return this.progressSubjects.filter(itm => itm.semesterId == semesterId)[0].subjects;
  }
  getReportStudentInfo()
  {
    this.svc.getReportStudentInfo(this.selectedStudentId).subscribe(data =>{
      // console.log(data);
      this.reportStudentInfo = data;
      // console.log(this.reportStudentInfo);
      // this.selectedClassId = this.reportStudentInfo.studentBasicInformation.classId;
      // this.getGradeScaleByClassId();
    });
  }
  getStudentAttendaceByStudentId()
  {
    this.attendaceSrv.GetStudentAttendaceByStudentId(this.selectedStudentId).subscribe((data: StudentAttendace) => {
      this.studentAttendance = data;
      // console.log(this.studentAttendance);
    });
  }

  getCceSubCriteriaMark(assessmentId,assessmentId2,val)
  {
    if(assessmentId == assessmentId2)
    {
      return val;
    }
    else
    {
      return null;
    }
  }

  getStudentAssessmentMark(assessments, assmtId)
  {
    if (assessments)
    {
      // console.log(assessments.filter(itm => itm.assessmentId == assmtId)[0].mark);
      if(assessments.filter(itm => itm.assessmentId == assmtId)[0])
      return assessments.filter(itm => itm.assessmentId == assmtId)[0].mark;
    }
  }
  // changeStatus(event)
  // {
  //   let target = event.target;
  //   if(!$(target).hasClass('active'))
  //   {
  //     $('.change_status.active').removeClass('active'); 
  //     $(target).addClass('active');
  //     this.toastr.success('Save Successfully.', '');
  //   }
  // }
  printReport(divId) {
      let element = $(divId).html();
      let settings ='';

         settings = `<style>
         @media print {
            *
            {
                -webkit-print-color-adjust: exact;
            }
            .textFormC
            {
                color:#000;
            }
          }
          body{display:none;}
       </style>`;

      element = '<div class="report_cards" id="printedDiv">' + element + settings + '</div>'; 
      $('html').append(element);
      window.print();
      $('#printedDiv').remove();
  }
}
